module.exports = __webpack_public_path__ + "static/media/calendar.a2356254.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/calendar.svg
// module id = 32
// module chunks = 0